import React from 'react';
import PropTypes from 'prop-types';
import { DarkButton, DarkText } from '@lyearn-team/frontend-components';
import * as s from './style';

class NavigationFooter extends React.PureComponent {
  render() {
    const { previous, next } = this.props;
    return (
      <div className={s.footerRoot}>
        <div className="section previous">
          {previous.label && !previous.hidden ? (
            <DarkButton.TextButton onClick={previous.onClick}>
              <DarkText color="sapphire" fontSize={12} letterSpacing={2} uppercase={true}>
                {previous.label}
              </DarkText>
            </DarkButton.TextButton>
          ) : null}
          {previous.title && !previous.hidden ? (
            <DarkText color="iron" className="title">
              {previous.title}
            </DarkText>
          ) : null}
        </div>
        <div className="section next">
          {next.label && !next.hidden ? (
            <DarkButton.TextButton onClick={next.onClick}>
              <DarkText color="sapphire" fontSize={12} letterSpacing={2} uppercase={true}>
                {next.label}
              </DarkText>
            </DarkButton.TextButton>
          ) : null}
          {next.title && !next.hidden ? (
            <DarkText color="iron" className="title">
              {next.title}
            </DarkText>
          ) : null}
        </div>
      </div>
    );
  }
}

const shapedProps = PropTypes.shape({
  label: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
});

NavigationFooter.propTypes = {
  previous: shapedProps,
  next: shapedProps
};

NavigationFooter.defaultProps = {
  previous: {
    label: 'Previous',
    title: '',
    onClick: console.log,
    disabled: false
  },
  next: {
    label: 'Next',
    title: '',
    onClick: console.log,
    disabled: false
  }
};

export default NavigationFooter;
